import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { throwError } from 'rxjs';
import { first, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BlockedContentDialogComponent } from '../app/shared/blocked-content-dialog/blocked-content-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class BlockedContentService {
  private serviceBaseUrl = '/api/v2/users';

  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
  ) {}

  public showPopup() {
    this.dialog.open(BlockedContentDialogComponent, {});
  }

  public checkApi(): any {
    return this.http
      .get(this.serviceBaseUrl)
      .pipe(
        first(),
        catchError(err => throwError(err)),
      );
  }

  public showWarningMessage(openedWindow: any) {
    window.setTimeout(() => {
      if (!openedWindow || openedWindow.closed || typeof openedWindow.closed === 'undefined') {
        this.checkApi().subscribe(
          resp => {},
          err => {
            if (err.status !== 0) {
              this.showPopup();
            }
          },
        );
      }
    }, 500);
  }
}
